import MUIPauseIcon from '@mui/icons-material/Pause';
import { SvgIconProps } from '@mui/material/SvgIcon';
import React from 'react';

const PauseIcon = (props: SvgIconProps) => <MUIPauseIcon {...props} />;
export default PauseIcon;
